<template>
  <div class="foot">
    <div class="main">
      <div class="left">
        <div class="inline-1">
          <img src="../assets/images/logo.png" alt />
        </div>
        <div class="inline-2">
          <span class="large">SDChain</span>
          <!--<p>{{$t('common.footer')}}</p>-->
        </div>
      </div>
      <div class="right">
        <div class="row-1">
          <a href="https://twitter.com/sixdomainchain" title="Twitter">
            <img class="a1" src="../assets/images/foot/foot1.png" />
            <img class="a2" src="../assets/images/foot/foot1-1.png" />
          </a>
          <a href="https://medium.com/@sixdomainchain" title="Medium">
            <img class="a1" src="../assets/images/foot/foot2.png" />
            <img class="a2" src="../assets/images/foot/foot2-1.png" />
          </a>
          <a href="https://m.weibo.cn/u/6447552031"  title="Weibo">
            <img class="a1" src="../assets/images/foot/foot3.png" alt />
            <img class="a2" src="../assets/images/foot/foot3-1.png" alt />
          </a>
          <a href="https://www.facebook.com/SDchainChinese" title="Facebook">
            <img class="a1" src="../assets/images/foot/foot4.png" alt />
            <img class="a2" src="../assets/images/foot/foot4-1.png" alt />
          </a>
          <a href="https://www.reddit.com/r/SDChain/"  title="Reddit">
            <img class="a1" src="../assets/images/foot/foot5.png" alt />
            <img class="a2" src="../assets/images/foot/foot5-1.png" alt />
          </a>
          <a href="https://www.youtube.com/channel/UCJE7KeNkXBm0TPjHCouTMpQ" title="YouTube">
            <img class="a1" src="../assets/images/foot/foot6.png" alt />
            <img class="a2" src="../assets/images/foot/foot6-1.png" alt />
          </a>
          <a href="https://t.me/sdchaincn"  title="Telegram">
            <img class="a1" src="../assets/images/foot/foot7.png" alt />
            <img class="a2" src="../assets/images/foot/foot7-1.png" alt />
          </a>
          <a href="https://github.com/SDChain/" title="Github">
            <img class="a1" src="../assets/images/foot/foot8.png" alt />
            <img class="a2" src="../assets/images/foot/foot8-1.png" alt />
          </a>
          <a href="https://forum.sdchain.io/" title="forum">
            <img class="a1" src="../assets/images/foot/foot9.png" alt />
            <img class="a2" src="../assets/images/foot/foot9-1.png" alt />
          </a>
        </div>
        <!-- <div class="row-2">
          <a v-for="(nav,index) in menu" :key="index" @click="jump(nav.url, nav.target)">{{ $t('menu.' + nav.tit) }}</a>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Foot",
  data() {
    return {
      menu: [
        {
          tit: "home",
          url: "/",
          target: "self"
        },
        {
          tit: "service",
          url: "/service",
          target: "self"
        },
        {
          tit: "cochain",
          url: "/cochain",
          target: "self"
        },

        {
          tit: "developer",
          url: "/developer",
          target: "self"
        },
        {
          tit: "team",
          url: "/team",
          target: "self"
        },
        {
          tit: "message",
          url: "/message",
          target: "self"
        },
        {
          tit: "wallet",
          url: "/wallet",
          target: "self"
        },
        {
          tit: "browser",
          url: "https://holographic.sdchain.io/",
          target: "blank"
        }
      ]
    };
  },
  methods: {
    jump(url, target) {
      if (target == "self") {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    }
  }
};
</script>

<style scoped lang="less">
@import url("../assets/css/var.less");

.foot {
  background-color: #315dd2;
  // padding: 28px 0;
  min-width: @min-width;
  height: 170px;
  .main {
    .clearfix();

    .left {
      float: left;
      width: 45%;
      margin-top: 48px;
      font-size: 0;
      .inline-1 {
        display: inline-block;
        vertical-align: middle;

        img {
          height: 85px;
          position: relative;
          top: 4px;
          margin-right: 5px;
        }
      }

      .inline-2 {
        display: inline-block;
        vertical-align: middle;

        .large {
          //margin-bottom: 5px;
          display: block;
          font-size: 24px;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
        }

        p {
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
      }
    }

    .right {
      float: right;
      width: 55%;
      padding-top: 50px;

      .row-1 {
        width: 80%;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        font-size: 28px;
        padding-left: 5px;

        a {
          padding: 0 8px;
          font-size: 48px;
          @media screen and (max-width: @max-width) {
            font-size: 48px;
          }
          color: #fff;
          .a2 {
            display: none;
            position: relative;
            top: 4.6px;
          }
          img {
            height: 48px;
            width: 48px;
            border: none;
          }

          &:nth-child(1):hover {
            .a1 {
              display: none;
            }
            .a2 {
              display: block;
            }
          }
          &:nth-child(2):hover {
            .a1 {
              display: none;
            }
            .a2 {
              display: block;
            }
          }
          &:nth-child(3):hover {
            .a1 {
              display: none;
            }
            .a2 {
              display: block;
            }
          }
          &:nth-child(4):hover {
            .a1 {
              display: none;
            }
            .a2 {
              display: block;
            }
          }
          &:nth-child(5):hover {
            .a1 {
              display: none;
            }
            .a2 {
              display: block;
            }
          }
          &:nth-child(6):hover {
            .a1 {
              display: none;
            }
            .a2 {
              display: block;
            }
          }
          &:nth-child(7):hover {
            .a1 {
              display: none;
            }
            .a2 {
              display: block;
            }
          }
          &:nth-child(8):hover {
            .a1 {
              display: none;
            }
            .a2 {
              display: block;
            }
          }
          &:nth-child(9):hover {
            .a1 {
              display: none;
            }
            .a2 {
              display: block;
            }
          }
        }
      }

      .row-2 {
        width: 80%;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        font-size: 10px;
        padding-left: 3px;

        a {
          font-size: 10px;
          @media screen and (max-width: @max-width) {
            font-size: 12px;
          }
          color: #999;
        }
      }
    }
  }
}
</style>
